import * as Yup from 'yup';

export const InquiriesSchema = Yup.object({
    first_name: Yup.string()
        .trim()
        .required('The first name field is required.'),
    last_name: Yup.string()
        .trim()
        .required('The last name field is required.'),
    contact_no: Yup.string()
        .trim()
        .required('The contact number field is required.'),
    email: Yup.string()
        .trim()
        .required('The email field is required.'),
    // token: Yup.string().required("Error Verification, Please try again."),
    message: Yup.string()
        .required('The message field is required.'),
    category: Yup.string()
        .required('The category field is required.'),
})

// export const InquiriesSchema = {
//     first_name: Yup.string()
//         .trim()
//         .required('The first name field is required.'),
//     last_name: Yup.string()
//         .trim()
//         .required('The last name field is required.'),
//     contact_no: Yup.string()
//         .trim()
//         .required('The contact number field is required.'),
//     email: Yup.string()
//         .trim()
//         .required('The email field is required.'),
//     message: Yup.string()
//         .required('The message field is required.'),
// }
// export const InquiriesSchema = {
//     first_name: Yup.string()
//         .trim()
//         .required('The first name field is required.'),
//     last_name: Yup.string()
//         .trim()
//         .required('The last name field is required.'),
//     contact_no: Yup.string()
//         .trim()
//         .required('The contact number field is required.'),
//     email: Yup.string()
//         .trim()
//         .required('The email field is required.'),
//     message: Yup.string()
//         .required('The message field is required.'),
// }

export const InquiriesReplySchema = Yup.object({
    reply: Yup.string()
        .required('The reply field is required.'),
})

export const InquiriesDeleteSchema = Yup.object({
    id: Yup.number()
        .required('The inquiry ID is required.'),
})

export default InquiriesSchema;
